module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('toast')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79740776"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 2234
// module chunks = 1